const BASE_API = process.env.REACT_APP_BASE_URL;
import Cookies from 'js-cookie';

//fetch subscription status
export const subscription = async (access_token) => {
  try {
    const response = await fetch(`${BASE_API}/accounts/subscription`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: access_token,
      },
    });

    if (response.ok) {
      const { data } = await response.json();
      return { success: true, data };
    } else {
      const errorMessage = await response.text();
      return { success: false, message: errorMessage };
    }
  } catch (error) {
    console.error("Error fetching subscription status:", error.message);
    return {
      success: false,
      message: "Error occurred while fetching subscription status",
    };
  }
};

//subscribe or unsubscribe
export const subscribe = async (access_token, newsletter, method) => {
  try {
    const response = await fetch(`${BASE_API}/accounts/subscription`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${access_token}`, // Include the user's access token
      },
      body: JSON.stringify({
        subscribe: newsletter,
        method: method,
      }),
    });
    if (response.ok) {
      return { success: true }; // Otp in preference updated successfully
    } else {
      return { success: false, message: "Error updating opt in preference" }; // Error updating newsletter status
    }
  } catch (error) {
    console.error("Error updating opt in preference: ", error.message);
    return {
      success: false,
      message: "Error occurred while updating opt in preference",
    }; // Error occurred while updating newsletter status
  }
};

// User registration with language preference for the response
export const register = async (userData) => {
  try {
    const formData = new FormData();

    // Append each field from userData to the FormData object
    for (let key in userData) {
      formData.append(key, userData[key]);
    }

    // Set header for Accept-Language based on the language parameter
    const headers = {
      Accept: "application/json",
    };

    const response = await fetch(`${BASE_API}/accounts/register`, {
      method: "POST",
      body: formData,
      headers: headers, // Include the headers object in the fetch options
    });

    if (response.ok) {
      console.log("User registered successfully.");
      return { success: true };
    } else {
      console.error(`Registration failed: ${response.message}`);
      return { success: false, error: response.message };
    }
  } catch (error) {
    console.error(`Error during registration: ${error.message}`);
    return { success: false, error: error.message };
  }
};

//fetch user info
export const show = async () => {
  try {
    const accessToken = Cookies.get('access_token');
    if (!accessToken) {
      return { success: false, message: "Access token is missing" };
    }

    const response = await fetch(`${BASE_API}/accounts/show`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: accessToken,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const { data, meta } = await response.json();
      if (response.ok) {
        return { data, meta };
      }
    } else {
      console.error("Response is not JSON:", await response.text());
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("Error fetching account information:", error);
    throw new Error("Failed to fetch account information");
  }
};

// Account recovery with language preference for the response
export const recover = async (userData) => {
  try {
    const formData = new FormData();

    // Append each field from userData to the FormData object
    for (let key in userData) {
      formData.append(key, userData[key]);
    }

    // Set header for Accept-Language based on the language parameter
    const headers = {
      Accept: "application/json",
    };

    const response = await fetch(`${BASE_API}/accounts/recover`, {
      method: "POST",
      body: formData,
      headers: headers, // Include the headers object in the fetch options
    });

    if (response.ok) {
      console.log("Account recovery initiated successfully.");
      return { success: true };
    } else {
      console.error(`Recovery failed: ${response.message}`);
      return { success: false, error: response.message };
    }
  } catch (error) {
    console.error(`Error during account recovery: ${error.message}`);
    return { success: false, error: error.message };
  }
};

//fetch user electronic entries summary
export const electronic_entries_summary = async ({ promotionIds = [], poker_ids = [], egd_ids = [] } = {}) => {
  // Early return if no promotion IDs are provided
  if (promotionIds.length === 0 && poker_ids.length === 0 && egd_ids.length === 0) {
    console.error("No promotion IDs were provided");
    return null;
  }

  try {
    const accessToken = Cookies.get('access_token');
    if (!accessToken) {
      return { success: false, message: "Access token is missing" };
    }

    // Build query string with all parameter types for smooth API transition
    let url = `${BASE_API}/accounts/electronic_entries`;
    const queryParams = new URLSearchParams();

    // Add current format parameters (backward compatibility)
    if (promotionIds.length > 0) {
      promotionIds.forEach(id => queryParams.append('promotion_ids[]', id));
    } // else send the ID of an old promo to avoid receiving them all.
    else {
      queryParams.append('promotion_ids[]', '3BD44206-2BD6-44E1-8845-01C7A839ADF6');
    }

    // Add future format parameters (forward compatibility)
    if (poker_ids.length > 0) {
      poker_ids.forEach(id => queryParams.append('poker_ids[]', id));
    }
    if (egd_ids.length > 0) {
      egd_ids.forEach(id => queryParams.append('egd_ids[]', id));
    }

    if (queryParams.toString()) {
      url = `${url}?${queryParams.toString()}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: accessToken,
      },
    });

    // Let the component handle the error
    // if (!response.ok) {
    //   throw new Error(`HTTP error! Status: ${response.status}`);
    // }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const responseData = await response.json();
      if (response.ok) {
        // Transform the new nested data structure to match expected format
        const transformedData = transformElectronicEntriesData(responseData);
        return transformedData;
      } else {
        // Return error response to component instead of throwing
        return responseData; // This will be the error fixture: { type: "error", code: 401, ... }
      }
    } else {
      console.error("Response is not JSON:", await response.text());
      throw new Error("Response is not JSON");
    }
  } catch (error) {
    console.error("Error fetching electronic entries:", error);
    throw new Error("Failed to fetch electronic entries");
  }
};

// Transform new nested data structure to expected format
const transformElectronicEntriesData = (responseData) => {
  const { data, meta } = responseData;
  const { poker_draws = [], egd_draws = [], as_of } = data;

  // Transform poker draws
  const transformedPokerDraws = poker_draws.map(entry => ({
    promotion_id: entry.id,
    promotion_name: entry.name,
    total_tickets: entry.tickets_count || 0,
    is_active: entry.is_active,
    display_order: entry.display_order,
    last_activity_date: entry.last_activity_date,
    start_hour: entry.start_hour,
    start_date: entry.start_date,
    end_hour: entry.end_hour,
    end_date: entry.end_date,
    any_day: entry.any_day,
    monday: entry.monday,
    tuesday: entry.tuesday,
    wednesday: entry.wednesday,
    thursday: entry.thursday,
    friday: entry.friday,
    saturday: entry.saturday,
    sunday: entry.sunday,
    type: 'poker',
    as_of: as_of
  }));

  // Transform EGD draws
  const transformedEgdDraws = egd_draws.map(entry => ({
    promotion_id: entry.id,
    promotion_name: entry.name,
    total_tickets: entry.tickets_count || 0,
    start_date: entry.start_date,
    end_date: entry.end_date,
    type: 'egd',
    as_of: as_of
  }));

  // Merge both arrays
  const promotions = [...transformedPokerDraws, ...transformedEgdDraws];

  return {
    data: {
      promotions: promotions,
      as_of: as_of
    },
    meta
  };
};

// Keep the old function name for backward compatibility during transition
export const poker_promos_summary = electronic_entries_summary;
